import React from 'react';
import ReactToggle from 'react-toggle';

class BottomBarPanel extends React.Component {
  constructor(props) {
    super(props);
    let bottombarData = {
      bottombar: false,
      bottompagination: false,
    };
    if ('bottombarData' in this.props) {
      bottombarData = this.props.bottombarData ? this.props.bottombarData : bottombarData;
    }
    this.state = {
      bottombarData,
    };
  }
  handleAttributeOnOff(element) {
    const elmData = this.state.bottombarData;
    if (elmData[element] === 'false' || elmData[element] === false || elmData[element] === undefined) {
      elmData[element] = true;
    } else {
      elmData[element] = false;
    }
    this.props.onBottomBarSubmit(elmData);
  }
  render() {
    const { bottombarData } = this.state;
    return (<div role="tabpanel" className="tab-pane" id="botombar">
      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_BOTTOMBAR}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
          <ReactToggle
            defaultChecked={bottombarData.bottombar === 'true'}
            onChange={this.handleAttributeOnOff.bind(this, 'bottombar')}
          />
        </div>
      </div>

      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_BOTTOMBAR_PAGINATION}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
          <ReactToggle
            defaultChecked={bottombarData.bottompagination === 'true'}
            onChange={this.handleAttributeOnOff.bind(this, 'bottompagination')}
          />
        </div>
      </div>
      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_BOTTOMBAR_LOADMORE}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
          <ReactToggle
            defaultChecked={bottombarData.bottomloadMore === 'true'}
            onChange={this.handleAttributeOnOff.bind(this, 'bottomloadMore')}
          />
        </div>
      </div>
    </div>);
  }
}

export default BottomBarPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/bottombarPanel.js
 **/